export default __webpack_public_path__ + "static/media/sl3-thumb.c5f4eb12.png";